const AdminUsers = {
  usersList: JSON.parse(process.env.REACT_APP_IAI_ADMIN_USERS || '[]'),
};

export default AdminUsers;
